import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useKeyboardShortcuts = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyPress = (e) => {
      // Check if user is typing in an input/textarea
      const isTyping = ['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName);
      
      // Ctrl/Cmd + key shortcuts
      if ((e.ctrlKey || e.metaKey) && !isTyping) {
        switch(e.key.toLowerCase()) {
          case 'd':
            e.preventDefault();
            navigate('/dashboard');
            break;
          case 'a':
            e.preventDefault();
            navigate('/accounts');
            break;
          case 'r':
            e.preventDefault();
            navigate('/reconciliations');
            break;
          case 'k':
            e.preventDefault();
            navigate('/analytics');
            break;
          case 'm':
            e.preventDefault();
            navigate('/mda');
            break;
          case 'f':
            e.preventDefault();
            navigate('/fpa');
            break;
          case '/':
            e.preventDefault();
            // Focus search if exists
            const searchInput = document.querySelector('input[type="search"], input[placeholder*="Search"]');
            if (searchInput) searchInput.focus();
            break;
          default:
            break;
        }
      }
      
      // Alt + key shortcuts (for quick actions)
      if (e.altKey && !isTyping) {
        switch(e.key.toLowerCase()) {
          case 'n':
            e.preventDefault();
            // Trigger "New" button click if exists
            const newButton = document.querySelector('[data-shortcut="new"]');
            if (newButton) newButton.click();
            break;
          case 's':
            e.preventDefault();
            // Trigger "Save" button click if exists
            const saveButton = document.querySelector('[data-shortcut="save"]');
            if (saveButton) saveButton.click();
            break;
          case 'e':
            e.preventDefault();
            // Trigger "Export" button click if exists
            const exportButton = document.querySelector('[data-shortcut="export"]');
            if (exportButton) exportButton.click();
            break;
          default:
            break;
        }
      }

      // Question mark to show shortcuts help
      if (e.key === '?' && !isTyping) {
        e.preventDefault();
        // Show shortcuts modal or toast
        const event = new CustomEvent('show-shortcuts-help');
        window.dispatchEvent(event);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [navigate]);
};

export const SHORTCUTS = {
  navigation: [
    { keys: ['Ctrl', 'D'], action: 'Go to Dashboard', mac: ['⌘', 'D'] },
    { keys: ['Ctrl', 'A'], action: 'Go to Accounts', mac: ['⌘', 'A'] },
    { keys: ['Ctrl', 'R'], action: 'Go to Reconciliations', mac: ['⌘', 'R'] },
    { keys: ['Ctrl', 'K'], action: 'Go to Analytics', mac: ['⌘', 'K'] },
    { keys: ['Ctrl', 'M'], action: 'Go to MD&A', mac: ['⌘', 'M'] },
    { keys: ['Ctrl', 'F'], action: 'Go to FP&A', mac: ['⌘', 'F'] },
    { keys: ['Ctrl', '/'], action: 'Focus Search', mac: ['⌘', '/'] },
  ],
  actions: [
    { keys: ['Alt', 'N'], action: 'Create New Item', mac: ['⌥', 'N'] },
    { keys: ['Alt', 'S'], action: 'Save Current Form', mac: ['⌥', 'S'] },
    { keys: ['Alt', 'E'], action: 'Export Data', mac: ['⌥', 'E'] },
  ],
  help: [
    { keys: ['?'], action: 'Show Keyboard Shortcuts', mac: ['?'] },
  ]
};
